import { Icon, ICONS_ENUM, Tooltip, Typography } from '@sanlam-glacier/app-common/components';
import { InvestmentBreakdown } from 'stores/dashboard-store/dashboard-store';
import styles from './beneficiaries.module.scss';
import BeneficiaryTooltipContent from './BeneficiaryTooltipContent';

interface BeneficiaryProps {
  firstName: string;
  lastName: string;
  investmentDetails: InvestmentBreakdown[];
  index: number;
}

const BeneficiaryCard = ({ firstName, lastName, investmentDetails, index }: BeneficiaryProps) => {
  return (
    <>
      <div className={styles.cardUser}>
        <div data-testid={'beneficiaryUserIcon' + index} className={styles.personBackground}>
          <Typography variant={Typography.VARIANT.H2} color={Typography.COLOR.PRIMARY}>
            <Icon icon={ICONS_ENUM.SOCIAL_MEDIA_PERSON} />
          </Typography>
        </div>
        <Typography
          data-testid={'beneficiaryNames' + index}
          weight={Typography.WEIGHT.MEDIUM}
          variant={Typography.VARIANT.B3}
        >
          {firstName} {lastName}
        </Typography>
      </div>
      <div className={styles.cardUser}>
        <DashedLine index={index} />
        <Tooltip
          data-testid={'beneficiaryInvestmentsTooltip' + index}
          content={
            <BeneficiaryTooltipContent
              data-testid={'beneficiaryInvestmentTooltipContent' + index}
              investmentDetails={investmentDetails}
            />
          }
          className={styles.tooltip}
          position={Tooltip.POSITION.RIGHT_START}
        >
          <div data-testid={'beneficiaryChip' + index} className={styles.beneficiaryChip}>
            <Typography
              data-testid={'beneficiaryChipText' + index}
              weight={Typography.WEIGHT.NORMAL}
              variant={Typography.VARIANT.B3}
              color={Typography.COLOR.PRIMARY}
              className={styles.chipText}
            >
              {investmentDetails.length} linked investments
            </Typography>
            <Icon
              data-testid={'beneficiaryChipIcon' + index}
              icon={ICONS_ENUM.ACTION_2_INFO}
              className={styles.displayIconTooltip}
            />
          </div>
        </Tooltip>
      </div>
    </>
  );
};

export default BeneficiaryCard;

interface DashedLineProps {
  index: number;
}

const DashedLine = ({ index }: DashedLineProps) => {
  return (
    <svg
      data-testid={'beneficiaryDashedLine' + index}
      viewBox='0 32 32 32'
      width={32}
      height={32}
      className={styles.dashedLine}
    >
      <rect
        x='0'
        y='0'
        rx={4}
        ry={4}
        width='64'
        height='64'
        fill='none'
        stroke={'#15808D'}
        strokeWidth='1'
        className={styles.dashed}
      />
    </svg>
  );
};
